<pmt-action-modal 
    [title]="'assignments.information.cancel' | transloco" 
    [submitButtonIconCode]="''"
    [submitButtonText]="'modal.confirmButton' | transloco" 
    (submitted)="cancelAssignment()"
    class="custom-modal-limiter"
    [isSaving]="isLoading"
    >
    <form [formGroup]="cancellationForm">
        <div class="d-flex flex-column gap-3">
            <div class="alert alert-danger">
                <p>{{'assignments.information.cancellationAlert' | transloco }}</p>
            </div>
            <div>
                <label for="cancellationReason">
                    {{ "assignments.information.cancellationReason" | transloco }}
                </label>
                <textarea id="cancellationReason" class="form-control" formControlName="cancellationReason"
                    rows="3"></textarea>
            </div>
            <div class="form-check">
                <input 
                    class="form-check-input" 
                    type="checkbox" 
                    formControlName="isCancellationConfirmed"
                    id="isCancellationConfirmed"
                    pmtValidateOnBlur
                />
                <label class="form-check-label" for="isCancellationConfirmed">
                    {{ 'assignments.information.cancellationConfirm' | transloco }}
                </label>
                <div class="invalid-feedback">
                {{'shared.validation.required' | transloco}}.
                </div>
            </div>
            <ng-container *ngIf="isError">
                <p class="text-danger" *ngIf="errorMessage == null">{{'generalError' | transloco}}</p>
                <p class="text-danger" *ngIf="errorMessage != null">{{errorMessage}}</p>
            </ng-container>
        </div>

    </form>
</pmt-action-modal>